import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import {
  USER_REGISTERED_LISTINGS,
  USER_REGISTERED_LISTING_REMOVE,
} from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const registeredListingsReducers = (state = initialState, action) => {
  switch (action.type) {
    case USER_REGISTERED_LISTING_REMOVE: {
      const content = state.content.filter(
        ({ listing_id }) => listing_id !== action.listingId
      )

      return {
        ...state,
        content,
        fields: state.fields,
        total_elements: content.length,
        isLoading: false,
      }
    }
    default:
      return reducers.dataTable.tableFetchReducer(
        USER_REGISTERED_LISTINGS,
        state,
        action
      )
  }
}

export default combineReducers({
  data: registeredListingsReducers,
  tableInfo: tableReducer,
})

export { initialState, registeredListingsReducers }
